/*
 Created by qing on 2021/5/22
 Des: 级联选择
 */
import BaseItem from "../BaseItem"
import {
  DATA_TYPE__JSON, DEFAULT_VALUE__CURRENT_MEMBER,
  DEFAULT_VALUE__MEMBER,
  DEFAULT_VALUE__RELATE_DATA, DEFAULT_VALUE__RELATE_DATA_NEW, FORM_ITEM__CASCADE,
  FORM_ITEM__MEMBER, FORM_ITEM__TABLE
} from "../types"
import {defaultValueInit} from "../utils"
import {isObject} from "../../../assets/js/Untis";
import RelateRecord from "./RelateRecord";

class Cascade extends BaseItem {
  constructor() {
    super()

    this.showPath = 0  //是否显示层级路径
    this.chooseEnd = 0 //是否需要选择到最后一级
    this.cascadeType = "RELATE" //SIMPLE 简单模式 HARD 复杂模式 RELATE 关联记录模式
    //简单模式
    this.simpleTxt = ""   //简单模式的字符串
    this.relateType = "SELF" // SELF 本表 OTHER 其他
    // -----本表关联模式
    this.selfConfig = {
      appId: "",
      formId: "",
      parentFieldId: "",
      childFieldId: ""
    }
    //多表关联模式
    this.relateList = [
      {
        appId: "",
        formId: "",
        relateFieldId: ""
      }
    ]

    this.value = {
      value: '', // xxx/xxx/xxx
      originValueList: [
        // {
        //   index:1,
        //   appId:"",
        //   formId:"",
        //   instanceId:"",
        //   value:""
        // }
      ]
    }

    this.defaultValue = {
      defaultType: ''
    }
  }

  get title() {
    return this.fieldTitle || Cascade._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

Cascade._title = '级联选择'
Cascade.type = FORM_ITEM__CASCADE
Cascade.use = true
Cascade.icon = 'iconfont icon-jilianxuanze'
Cascade.prototype.icon = 'iconfont icon-jilianxuanze'

Cascade.prototype.type = Cascade.type
Cascade.prototype.dataType = DATA_TYPE__JSON
Cascade.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    label: '关联数据',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
  },
  {
    label: '关联数据2.0',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA_NEW)
  }
]
Cascade.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }

  if (val && !isObject(val)) {
    console.error('the value of member is not an object --> ', val, this.dataId)
    this.value = {
      value: '', // xxx/xxx/xxx
      originValueList: []
    }
    return
  }
  this.value = val || {
    value: '', // xxx/xxx/xxx
    originValueList: []
  }
}
Cascade.prototype.filterOpts = [
  {
    name: '等于任意一个',
    method: 'in'
  },
  {
    name: '不等于任意一个',
    method: 'nin'
  },
  {
    name: '包含',
    method: 'like'
  },
  {
    name: '不包含',
    method: 'unlike'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
Cascade.prototype.getValue = function () {
  return this.value
}
Cascade.prototype.setConf = function (opts) {
  this.setBase(opts)
  this.showPath = opts.showPath === 0 ? 0 : 1
  this.chooseEnd = opts.chooseEnd === 0 ? 0 : 1
  if (opts.cascadeType) {
    this.cascadeType = opts.cascadeType
  }
  if (opts.simpleTxt) {
    this.simpleTxt = opts.simpleTxt
  }
  if (opts.relateType) {
    this.relateType = opts.relateType
  }
  if (opts.selfConfig) {
    this.selfConfig = opts.selfConfig
  }
  if (opts.relateList) {
    this.relateList = opts.relateList
  }

  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
  }
}
Cascade.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    defaultValue: this.defaultValue,
    showPath: this.showPath,
    chooseEnd: this.chooseEnd,
    cascadeType: this.cascadeType,
    simpleTxt: this.simpleTxt,
    relateType: this.relateType,
    selfConfig: this.selfConfig,
    relateList: this.relateList
  }
}
Cascade.prototype.valueToString = function (value, opt = {}) {

  if (value && !isObject(value)) {
    console.error('the value of member is not an object「valueToString」 --> ', value, this.dataId)
    return ''
  }
  return this.value.value
}

export default Cascade
